var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophoneoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.219 0.253 c -0.963 -0.538 -2.183 -0.191 -2.721 0.773 l -7.19 12.897 C 59.57 6.124 52.989 0 45 0 c -8.481 0 -15.382 6.9 -15.382 15.382 v 29.044 c 0 5.12 2.497 9.802 6.631 12.652 l -4.31 7.732 c -5.706 -4.159 -9.183 -10.873 -9.183 -17.992 v -6.505 c 0 -1.104 -0.896 -2 -2 -2 s -2 0.896 -2 2 v 6.505 c 0 8.562 4.257 16.632 11.221 21.513 L 19.553 87.026 c -0.538 0.965 -0.191 2.183 0.773 2.721 C 20.634 89.919 20.968 90 21.298 90 c 0.702 0 1.383 -0.37 1.749 -1.026 l 47.945 -86 C 71.53 2.009 71.184 0.791 70.219 0.253 z M 33.618 44.426 V 15.382 C 33.618 9.106 38.724 4 45 4 c 6.276 0 11.382 5.106 11.382 11.382 v 5.583 L 38.216 53.549 C 35.349 51.422 33.618 48.081 33.618 44.426 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(30,153,215)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.245 38.312 c -1.104 0 -2 0.896 -2 2 v 6.505 c 0 12.266 -9.979 22.244 -22.245 22.244 c -2.1 0 -4.178 -0.292 -6.176 -0.867 c -1.06 -0.308 -2.169 0.308 -2.475 1.368 c -0.306 1.062 0.307 2.17 1.369 2.476 c 1.721 0.495 3.491 0.808 5.283 0.943 V 86 h -9.126 c -1.104 0 -2 0.896 -2 2 s 0.896 2 2 2 h 22.252 c 1.104 0 2 -0.896 2 -2 s -0.896 -2 -2 -2 H 47 V 72.978 c 13.54 -1.026 24.245 -12.363 24.245 -26.16 v -6.505 C 71.245 39.208 70.35 38.312 69.245 38.312 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(30,153,215)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.382 34.041 v 10.385 c 0 6.152 -5.002 11.256 -11.149 11.379 c -1.104 0.022 -1.981 0.936 -1.959 2.04 c 0.022 1.091 0.913 1.96 1.999 1.96 c 0.014 0 0.027 0 0.041 0 c 8.31 -0.167 15.069 -7.065 15.069 -15.379 V 34.041 c 0 -1.104 -0.896 -2 -2 -2 S 56.382 32.937 56.382 34.041 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(30,153,215)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneoff);
export default __webpack_public_path__ + "static/media/microphoneoff.59a00642bade7999f5fdcbf6e5629179.svg";
export { ForwardRef as ReactComponent };